import mixpanel from 'mixpanel-browser';

import {get} from '-/util/lodash';
import Service from './Service';
import {getCookie} from '-/util/util';
import config from '-/config/config';

class SessionService extends Service {
    constructor() {
        super();

        this.isCCR = false;
        this.username = null;

        if (!SessionService.instance) {
            SessionService.instance = this;
        }

        return SessionService.instance;
    }

    authenticated() {
        const {mode} = config;
        const isDev = ['development', 'development-build'].includes(mode);
        const hasSecureCookie = !!getCookie('__Secure-dod');
        const hasUnsecuredCookie = isDev && !!getCookie('dod');

        return hasSecureCookie || hasUnsecuredCookie;
    }

    getUsername() {
        return this.username;
    }

    initialize(data) {
        const {_id, isCCR, name} = data;

        this.isCCR = !!isCCR;
        this.username = name;

        mixpanel.register({
            'CCR Id': _id,
            'CCR Name': name
        });
        mixpanel.people.set({
            'CCR Name': name
        });
    }

    isCCRMode() {
        return !!this.isCCR;
    }

    isCCRDomain() {
        const host = get(window, 'location.host');
        const ccrDomains = ['refi.mcc.local:7070', 'refi.autoloandocsqa.com', 'refi.autoloandocs.com'];
        return ccrDomains.includes(host);
    }
}

export default new SessionService();
